export interface ProjectCostData {
  costMethod: CostCalculationMethod
  costPerSqFt?: number
  setupCost?: number
  customTotalCost?: number
}

export enum CostCalculationMethod {
  FEP_LEVEL_1 = 'FEP Level 1 Cost Estimation',
  SETUP_AND_MATERIAL = 'Setup and Material Cost Estimation',
  SIMPLE = 'Cost Estimation',
}

export const CostCalculationMethodTooltips: Record<
  CostCalculationMethod,
  string
> = {
  [CostCalculationMethod.FEP_LEVEL_1]: `
  Front-End Planning Level 1 Estimation of Project Cost: \n
  M = Material Cost \n
  E = Equipment Cost \n
  Labor = 2(M + E) \n
  Overhead = 0.5(M + E) \n
  Total = Labor + Overhead + M + E
  `,
  [CostCalculationMethod.SETUP_AND_MATERIAL]: `
    Material Cost = Material Area * Material Cost Per SqFt \n
    Total Cost = Material Cost + Setup Cost
  `,
  [CostCalculationMethod.SIMPLE]: 'Enter the estimated cost of the project',
}
